import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const Component = lazy(() => import('components/ai-maize-hybrid-harvest-automatic-alert-form'));

const AiMaizeHybridHarvestAutomaticAlertForm = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default AiMaizeHybridHarvestAutomaticAlertForm;
